import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useUser } from '../components/LoginPersistence';

const STORAGE_KEY = 'vrc-admin-show-version-widget';

const VersionWidgetContext = createContext({
  visible: false,
  setVisible: () => {},
  isAdmin: false,
});

export function VersionWidgetProvider({ children }) {
  const { user } = useUser();
  const isAdmin = user && (user.userType === 'admin' || user.isAdmin === true);

  const [visible, setVisibleState] = useState(() => {
    if (typeof window === 'undefined' || !isAdmin) return false;
    return window.localStorage.getItem(STORAGE_KEY) !== 'false';
  });

  const setVisible = useCallback((value) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
      setVisibleState(value);
    }
  }, []);

  useEffect(() => {
    if (!isAdmin) {
      setVisibleState(false);
      return;
    }
    setVisibleState(window.localStorage.getItem(STORAGE_KEY) !== 'false');
  }, [isAdmin]);

  const value = {
    visible: isAdmin && visible,
    setVisible,
    isAdmin: !!isAdmin,
  };

  return (
    <VersionWidgetContext.Provider value={value}>
      {children}
    </VersionWidgetContext.Provider>
  );
}

export function useVersionWidget() {
  const ctx = useContext(VersionWidgetContext);
  if (!ctx) {
    return { visible: false, setVisible: () => {}, isAdmin: false };
  }
  return ctx;
}
